import { render, staticRenderFns } from "./applyHouseCollection.vue?vue&type=template&id=2c2106d2&"
import script from "./applyHouseCollection.vue?vue&type=script&lang=js&"
export * from "./applyHouseCollection.vue?vue&type=script&lang=js&"
import style0 from "./applyHouseCollection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports